import * as React from 'react';

import { Divider } from '~shared/components/Divider';
import { Stack } from '~shared/components/Stack';

interface Props {
  children: React.ReactNode;
}

const EmailStudentsDialogFooter: React.FC = ({
  children,
}: React.PropsWithChildren<Props>) => {
  return (
    <Stack space="8">
      <Divider />
      <div className="flex flex-wrap justify-between">{children}</div>
    </Stack>
  );
};

export default EmailStudentsDialogFooter;
